// Komponenty Alpine.js
export const registerAlpineComponents = () => {
    window.Alpine.data('tabsHandler', () => ({
        activeTab: new URLSearchParams(window.location.search).get('action') === 'register' ? 'register' : 'login'
    }));

    window.Alpine.data('loginForm', () => ({
        showPassword: false,
        isLoading: false,
        loginError: null,

        async submitLoginForm() {
            this.isLoading = true;
            this.loginError = null;

            try {
                // Pobierz dane z formularza
                const formData = new FormData(this.$refs.loginForm);

                // Dodaj parametr login do URL
                const ajaxUrl = (window.wc_ajax_url || `${window.location.origin}/?wc-ajax=%endpoint%`)
                    .replace('%endpoint%', 'login');

                const response = await fetch(ajaxUrl, {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                });

                // Pobierz tekst odpowiedzi
                const responseText = await response.text();

                if (response.redirected) {
                    window.location.href = response.url;
                    return;
                }

                // Spróbuj przetworzyć odpowiedź
                let data;
                try {
                    if (responseText) {
                        data = JSON.parse(responseText);
                    }
                } catch (e) {
                    // Jeśli odpowiedź nie jest JSONem, sprawdź czy zawiera URL przekierowania
                    if (responseText.includes('redirect')) {
                        const match = responseText.match(/href=['"]([^'"]+)['"]/);
                        if (match) {
                            window.location.href = match[1];
                            return;
                        }
                    }
                }

                if (data && data.error) {
                    this.loginError = data.message;
                } else if (data && data.redirect) {
                    window.location.href = data.redirect;
                } else {
                    // Sprawdź czy odpowiedź zawiera informację o sukcesie
                    if (responseText.toLowerCase().includes('success') || response.status === 200) {
                        window.location.href = '/moje-konto/';
                    } else {
                        this.loginError = 'Nieprawidłowy login lub hasło';
                    }
                }

            } catch (error) {
                console.error('Login error:', error);
                this.loginError = 'Wystąpił błąd podczas logowania. Spróbuj ponownie.';
            } finally {
                this.isLoading = false;
            }
        }
    }));

    window.Alpine.data('registrationForm', () => ({
        currentStep: 1,
        totalSteps: 4,
        showPassword: false,
        accountType: 'business',
        passwordStrength: 0,
        isLoading: false,
        registrationError: null,
        usernameError: '',
        nipError: '',
        // Form data for summary
        formData: {
            email: '',
            username: '',
            firstName: '',
            lastName: '',
            companyName: '',
            companyNip: ''
        },
        passwordRequirements: {
            length: false,
            uppercase: false,
            lowercase: false,
            number: false,
            special: false
        },

        gotoStep(step) {
            if (this.validateCurrentStep()) {
                this.currentStep = step;
            }
        },

        nextStep() {
            if (this.validateCurrentStep()) {
                this.currentStep++;
                // Update form data when changing steps
                this.updateFormData();
            }
        },

        prevStep() {
            this.currentStep--;
            // Update form data when changing steps
            this.updateFormData();
        },

        // Update form data for summary display
        updateFormData() {
            this.formData = {
                email: document.getElementById('reg_email').value || '',
                username: document.getElementById('reg_username').value || '',
                firstName: document.getElementById('reg_first_name').value || '',
                lastName: document.getElementById('reg_last_name').value || '',
                companyName: document.getElementById('reg_company_name').value || '',
                companyNip: document.getElementById('reg_company_nip').value || ''
            };
        },

        validateCurrentStep() {
            if (this.currentStep === 1) {
                // Walidacja username i email
                const username = document.getElementById('reg_username').value;
                const email = document.getElementById('reg_email').value;

                if (!username || !email) {
                    this.registrationError = 'Proszę wypełnić wszystkie wymagane pola.';
                    return false;
                }

                if (!this.validateUsername(username)) {
                    return false;
                }

                if (!this.validateEmail(email)) {
                    this.registrationError = 'Proszę podać prawidłowy adres email.';
                    return false;
                }

                // Store form data
                this.updateFormData();

                this.registrationError = null;
                return true;
            }

            if (this.currentStep === 2) {
                // Walidacja danych kontaktowych
                const firstName = document.getElementById('reg_first_name').value;
                const lastName = document.getElementById('reg_last_name').value;
                const companyName = document.getElementById('reg_company_name').value;
                const nip = document.getElementById('reg_company_nip').value;

                if (!firstName || !lastName || !companyName || !nip) {
                    this.registrationError = 'Proszę wypełnić wszystkie wymagane pola.';
                    return false;
                }

                if (!this.validateNIP(nip)) {
                    return false;
                }

                // Store form data
                this.updateFormData();

                this.registrationError = null;
                return true;
            }

            if (this.currentStep === 3) {
                // Walidacja hasła
                const password = document.getElementById('reg_password').value;

                if (!password) {
                    this.registrationError = 'Proszę wprowadzić hasło.';
                    return false;
                }

                if (this.passwordStrength < 3) {
                    this.registrationError = 'Hasło jest zbyt słabe. Proszę wybrać silniejsze hasło.';
                    return false;
                }

                // Update form data before going to summary
                this.updateFormData();

                this.registrationError = null;
                return true;
            }

            // If going to last step, update form data for summary
            if (this.currentStep === 4) {
                this.updateFormData();
            }

            return true;
        },

        validateUsername(username) {
            if (!username) {
                this.usernameError = 'Proszę podać nazwę użytkownika.';
                return false;
            }
            if (!/^[a-zA-Z0-9\-_]+$/.test(username)) {
                this.usernameError = 'Nazwa użytkownika może zawierać tylko litery, cyfry, podkreślenia i myślniki.';
                return false;
            }
            this.usernameError = '';
            return true;
        },

        validateEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },

        checkPasswordStrength(password) {
            this.passwordRequirements = {
                length: password.length >= 8,
                uppercase: /[A-Z]/.test(password),
                lowercase: /[a-z]/.test(password),
                number: /[0-9]/.test(password),
                special: /[^A-Za-z0-9]/.test(password)
            };
            this.passwordStrength = Object.values(this.passwordRequirements).filter(Boolean).length;
        },

        validateNIP(nip) {
            nip = nip.replace(/[^0-9]/g, '');
            if (nip.length !== 10) {
                this.nipError = 'NIP musi mieć dokładnie 10 cyfr';
                return false;
            }

            const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
            let sum = 0;

            for (let i = 0; i < 9; i++) {
                sum += weights[i] * parseInt(nip[i]);
            }

            const checksum = sum % 11;
            if (checksum === 10 || checksum !== parseInt(nip[9])) {
                this.nipError = 'Nieprawidłowa suma kontrolna NIP';
                return false;
            }

            this.nipError = '';
            return true;
        },

        async submitRegistrationForm(event) {
            event.preventDefault();

            // Sprawdź walidację całego formularza
            if (!this.validateCurrentStep()) {
                return;
            }

            // Sprawdź zgodę na politykę prywatności
            const privacyPolicy = document.getElementById('privacy_policy');
            if (!privacyPolicy.checked) {
                this.registrationError = 'Musisz zaakceptować Politykę Prywatności, aby kontynuować.';
                return;
            }

            this.isLoading = true;
            this.registrationError = null;

            try {
                const formData = new FormData(event.target);
                formData.append('action', 'custom_register');
                formData.append('security', wc_ajax_params.nonce.register);

                const response = await fetch(wc_ajax_params.ajax_url, {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin'
                });

                const data = await response.json();

                if (data.success) {
                    if (data.data.verification_required) {
                        window.location.href = data.data.redirect + '?verification=required';
                    } else {
                        window.location.href = data.data.redirect;
                    }
                } else {
                    this.registrationError = data.data.message || 'Wystąpił błąd podczas rejestracji';
                }
            } catch (error) {
                console.error('Registration error:', error);
                this.registrationError = 'Wystąpił błąd podczas rejestracji. Spróbuj ponownie.';
            } finally {
                this.isLoading = false;
            }
        }
    }));
};

// W main.js:
document.addEventListener('alpine:init', () => {
    registerAlpineComponents();
});